import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Vacanciesimg from '../../Components/Vacancies/Vacanciesimg';
import CurrentJobOpening from '../../Components/Vacancies/CurrentJobOpening';

function Vacancies() {
    
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0,  }} >
        <div>
          <Header title="vacancies" />
        </div>

        <div>
          <Vacanciesimg/>
        </div>

        <div>
          <CurrentJobOpening/>
        </div>
        
        

     <div>
      <Footer/>
     </div>

      </Container>
    </div>
    
  );
}

export default Vacancies